import axios from 'axios';
import { urls } from '../config';

const token = JSON.parse(localStorage.getItem('sesion'))?.token;

export const getService = async (token, business, provider) => {
 const url = `${urls.services}/${business}/${provider}`;
 const headers = { 'x-access-token': token };
 const services = await axios.get(url, { headers });
 return services.data; // { count, rows }
};

export const getServices = async (id, business) => {
 const url = urls.service([id, business]);
 const headers = { 'x-access-token': token };
 const services = await axios.get(url, { headers });
 return services.data; // { count, rows }
};

/* export const getService = async token => {
  const url = urls.orders({ symbol, page, size });
  const headers = { 'x-access-token': token };
  const services = await axios.get(url, { headers });
  return services.data; // { count, rows }
}; */

export const updateService = async (token, newData, id) => {
 const url = urls.person(id);
 const headers = { 'x-access-token': token };
 const services = await axios.patch(url, newData, { headers });
 return services.data;
};

export const createService = async () => {
 const servicesData = [
  {
   title: 'Bronce',
   subTitle: 'Obtén todos los beneficios por un monto fijo.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'mes',
   collect: 0,
   days: 30,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 3000000.0,
   category: 'PROJECT',
   charge: 'FIXED CHARGE',
   traders: ['ALL'],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  },
  {
   title: 'Plata',
   subTitle: 'Paga solo por los que usas cuando vendes.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'semanal',
   collect: 0.01,
   days: 7,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 0.007,
   category: 'PROJECT',
   charge: 'WEEKLY CHARGE',
   traders: ['ALL'],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  },
  {
   title: 'Oro',
   subTitle: 'Paga solo cuando hayas recaudado el 30% de la venta.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'quincenal',
   collect: 0.3,
   days: 15,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 0.015,
   category: 'PROJECT',
   charge: 'FORTNIGHTLY CHARGE',
   traders: ['ALL'],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  },
  {
   title: 'Platino',
   subTitle: 'Paga solo cuando hayas recaudado el 60% de la venta.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'mensual',
   collect: 0.6,
   days: 30,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 0.025,
   category: 'PROJECT',
   charge: 'MONTHLY CHARGE',
   traders: ['ALL'],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  },
  {
   title: 'Standar',
   subTitle: 'Paga solo cuando hayas recaudado el 80% de la venta.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'trimestral',
   collect: 0.8,
   days: 90,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 0.03,
   category: 'PROJECT',
   charge: 'FIXED CHARGE',
   traders: [1],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  },
  {
   title: 'Premium',
   subTitle: 'Paga solo cuando hayas recaudado el 95% de la venta.',
   recurringPay: 1,
   isFeatured: 1,
   featureTitle: 'Modulos con acceso:',
   collection: 'semestral',
   collect: 0.95,
   days: 180,
   features: [
    { title: 'Reporte' },
    { title: 'Salidas y Enttradas' },
    { title: 'Cartera', tag: { label: 'Nuevo', type: 'success' } },
    { title: 'Ordenes' }
   ],
   status: 'ACTIVE',
   deal: 0.05,
   category: 'PROJECT',
   charge: 'FIXED CHARGE',
   traders: [1],
   executor: 'AUTO',
   description: 'DESCRIPCION DEL SERVCIO',
   sector: 'REAL ESTATE',
   business: 1
  }
 ];

 const url = urls.service();
 const headers = { 'x-access-token': token };
 for (var i = 0; i < servicesData.length; i++) {
  let newService = servicesData[i];
  const services = await axios.post(url, newService, { headers });
  console.log(newService, services, 'todo esta aqui y es la respueta');
 }
 /* servicesData.map(e => {
    axios.post(url, e, { headers });
  }); */
 console.log(url, 'todo salio bien como se pensaba');
 //const services = await axios.post(url, newService, { headers });
 return true; //services.data;
};

export const registerService = async newService => {
 const url = urls.service + '/register';
 const headers = { 'x-access-token': token };
 const services = await axios.post(url, newService, { headers });
 return services.data;
};

export const deletService = async (symbol, orderId, token) => {
 const url = urls.orders({ symbol, orderId });
 const headers = { 'x-access-token': token };
 const services = await axios.delete(url, { headers });
 return services.data; // { count, rows }
};

export const syncService = async (beholderOrderId, token, data = []) => {
 const url = urls.orders({ sync: true, beholderOrderId });
 const headers = { 'x-access-token': token };
 const services = await axios.post(url, data, { headers });
 return services.data; // { count, rows }
};

export default {
 getServices,
 getService,
 updateService,
 createService,
 deletService,
 syncService
};

/* Este código es un archivo de exportación de funciones que tienen un objetivo relacionado con servicios. Se importa la librería axios y un archivo de configuración llamado urls.

La primera línea de código establece una variable llamada token, la cual se obtiene de los datos almacenados en localStorage con la clave "sesion".

La primera función getServices toma dos argumentos, id y business, y devuelve una lista de servicios. La URL se crea con la función urls.service y los argumentos id y business. Se establecen cabeceras con un token y se utiliza axios para hacer una solicitud GET a la URL proporcionada. Los datos recibidos se devuelven.

La segunda función getService toma un argumento token y devuelve una lista de servicios. La URL se crea con la función urls.orders y los argumentos symbol, page y size. Se establecen cabeceras con un token y se utiliza axios para hacer una solicitud GET a la URL proporcionada. Los datos recibidos se devuelven.

La tercera función updateService toma tres argumentos, token, newData y id, y devuelve la información actualizada de un servicio. La URL se crea con la función urls.person y el argumento id. Se establecen cabeceras con un token y se utiliza axios para hacer una solicitud PATCH con los datos newData a la URL proporcionada. Los datos recibidos se devuelven.

La última función createService no toma argumentos y crea una nueva lista de servicios con datos predeterminados. Se devuelve la información del nuevo servicio creado. */
